import React from "react";
import "./index.less";
import CustomScrollView from "react-custom-scrollbars";
import { isIE } from "@/utils";
import { isFocusEnv } from "@/utils";

export function isLowFirefox() {
  let ua = navigator.userAgent;
  if (ua.indexOf("Firefox") > -1) {
    if ("scrollbarWidth" in document.documentElement.style) {
      return false;
    }
    return true;
  }
  return false;
}

function ScrollView(opts: any, ref: any = null) {
  // const onScroll = (e: any) => {
  //     if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
  //         // 滚动到底部需要做的事情
  //     }
  //     if (opts.onScroll) {
  //         opts.onScroll(e);
  //     }
  // };
  const defaultStyle = {
    position: "absolute",
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    overflow: isLowFirefox() ? "auto" : "scroll",
    marginRight: !isFocusEnv() ? "0px" : isIE() ? "-18px" : "-8px",
    marginBottom: isIE() ? "-18px" : "-8px",
    with: "64px",
    ...opts.style
  };

  const scrollBarSize = opts.scrollBarSize || "6px";

  return (
    <CustomScrollView
      ref={ref}
      autoHide={true}
      renderTrackVertical={() => (
        <div
          className="vertiScroll"
          id="message-box-container-basScroll"
          style={{
            position: "absolute",
            width: scrollBarSize,
            transition: "opacity 200ms ease 0s",
            opacity: "0",
            right: "0px",
            bottom: "2px",
            top: "2px",
            borderRadius: "3px",
            zIndex: 99
          }}
        />
      )}
      renderTrackHorizontal={() =>
        opts.nohorizontal ? (
          <div />
        ) : (
          <div
            className="horiScroll"
            style={{
              position: "absolute",
              height: scrollBarSize,
              transition: "opacity 200ms ease 0s",
              opacity: "0",
              right: "2px",
              bottom: "2px",
              left: "2px",
              borderRadius: "3px",
              zIndex: 99
            }}
          />
        )
      }
      renderView={(props) => (
        <div
          {...props}
          className="scroll-view-content base-view-content"
          style={opts.nohorizontal ? { ...defaultStyle, overflowX: "hidden" } : defaultStyle}
        />
      )}
      {...opts}
    />
  );
}

export default React.forwardRef(ScrollView);
